<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch10">
<div class="chapterHead">
<h2 class="chapterTitle2"><span class="xrefInternal"><a href="#/contents#ch_10"><span class="bold">J<span class="smallCaps">AMES</span> B<span class="smallCaps">ROWN</span></span></a></span><span class="footnoteRef"><span href="#/footnote#footnote10" id="fn10" title="Link target outside of Sample"><sup>*</sup></span></span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText">T<span class="smallCaps">HE</span> B<span class="smallCaps">EATLES WERE ONE-OF-A-KIND AND A BLESSING TO THE MUSIC WORLD, EACH AND EVERY ONE OF THEM.</span> J<span class="smallCaps">OHN WAS EXTREMELY TALENTED—HE SEEMED TO HAVE A LOT ON HIS MIND, BUT IT NEVER HURT HIS MUSIC, SO</span> I <span class="smallCaps">CAN TRULY</span> say: I think there will never be another like that beautiful brother, may God bless his soul and his family. John, we will never forget you.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch10.vue?45ef1594